import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import {VuetifyGooglePlaces} from 'vue-google-places'

import {OverlayScrollbarsPlugin} from 'overlayscrollbars-vue';
//Google Tag Manager implementation
import VueGtm from 'vue-gtm';
//import VueRouter from 'vue-router';
//const router = new VueRouter({ routes, mode, linkActiveClass });
import StoryblokVue from 'storyblok-vue'
import StoryblokClient from 'storyblok-js-client'

import * as Sentry from '@sentry/browser';

//const sb_token = process.env.VUE_STORYBLOK_TOKEN
const sb_token = 'c2rQf3f9sRzde6cW9uY2xAtt'

Vue.prototype.$storyapi = new StoryblokClient ({
    accessToken: sb_token
})

Vue.use (StoryblokVue)

Vue.use (VueGtm, {
    id: 'GTM-5LBBGQS', // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']

    // queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
    //     gtm_auth:'AB7cDEf3GHIjkl-MnOP8qr',<
    //     gtm_preview:'env-4',
    //     gtm_cookies_win:'x'
    // },
    defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    loadScript: false, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    //vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    //ignoredViews: ['homepage'], // Don't trigger events for specified router names (case insensitive) (optional)
    trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
});
//End of GTM Implementation
Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
  
    // This sets the sample rate to be 0%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0,
  
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
  
    integrations: [
      new Sentry.Replay({
        // Additional SDK configuration goes in here, for example:
        maskAllText: false,
        maskAllInputs: true,
        blockAllMedia: false,
        stickySession: true,
        minReplayDuration: 5,
      }),
    ],
  });
  
Vue.use(OverlayScrollbarsPlugin);
Vue.use(VuetifyGooglePlaces)

Vue.config.productionTip = false

new Vue({
    vuetify,
    render: h => h(App)
}).$mount('#catalog-vue-app')
